export const camadasDiagnostico = [
    'TERRA_INDIGENA',
    'TERRA_INDIGENA_PARAGUAI',
    'AREA_EMBARGADA',
    'PRODES',
    'MORATORIA_SOJA',
    'AREA_EMBARGADA_ICMBIO',
    'AREA_EMBARGADA_SEMA_MT',
    'AREA_EMBARGADA_GOIAS',
    'MORATORIA_SOJA_PONTOS',
    'LISTA_AREA_EMBARGADA',
    'PROTOCOLO_VERDE_GRAOS',
    'LISTA_SUJA_TRABALHO_ESCRAVO',
    'HISTORICO_LISTA_SUJA_TRABALHO_ESCRAVO',
    'PESSOA_POLITICAMENTE_EXPOSTA',
    'AMAZONIA_PROTEGE',
    'LDI',
    'UNIDADE_CONSERVACAO_US',
    'UNIDADE_CONSERVACAO_PI',
    'ZONA_AMORTECIMENTO_UNIDADE_CONSERVACAO_PI',
    'MMA_PRODES_BIOMAS',
    'LISTA_MMA_PRODES_CAR',
    'PRODES_CERRADO',
    'DETER_AMAZONIA',
    'DETER_CERRADO',
    'QUEIMADAS',
    'SITIOS_ARQUEOLOGICOS',
    'INCRA_ASSENTAMENTOS',
    'INCRA_QUILOMBOLAS',
    'DESMATAMENTO_MAPBIOMAS',
    'SISTEMA_ALERTAS_DESMATAMENTO_BIOMA_AMAZONIA',
    'AREA_RELEVANTE_INTERESSE_ECOLOGICO_ARIE',
    'AREA_PROTECAO_AMBIENTAL_APA',
    'APP',
    'UNIDADE_CONSERVACAO',
    'POVOS_COMUNIDADES_TRADICIONAIS',
    'AUTO_INFRACAO_SIGAM_SP',
    'FUNDACAO_PALMARES',
    'AREAS_PRIORITARIAS',
    'MONITORAMENTO_DESMATAMENTO',
    'AREA_EMBARGADA_SEDAM_RO',
    'AREA_EMBARGADA_RO',
    'AREA_EMBARGADA_SC',
    'AREA_EMBARGADA_RO_PONTO',
    'DESMATAMENTO_INFONA_PARAGUAI',
    'SITIO_RAMSAR_PARAGUAI',
    'RESERVA_BIOSFERA_PARAGUAI',
    'AREAS_SILVESTRES_PROTEGIDAS_PARAGUAI',
    'FLORESTAS_PUBLICAS',
    'AREA_EMBARGADA_PIAUI',
    'PRODES_PANTANAL',
    'PRODES_MATA_ATLANTICA',
    'PRODES_PAMPA',
    'PRODES_CAATINGA',
    'AREA_EMBARGADA_SIGA_MT_POLIGONO',
    'AREA_EMBARGADA_SIGA_MT_PONTO',
    'LISTA_AREA_EMBARGADA_SEMA_MT',
    'AREA_EMBARGADA_PARANA',
    'DESMATAMENTO_EUDR',
    'DESMATAMENTO_GFW_PARAGUAI',
    'SITUACAO_CAR',
    'SITUACAO_CAR_SANTANDER', // TODO: [OPERACAO] Código SITUACAO_CAR_SANTANDER é antigo, remover quando corrigir todo passivo.
    'PROCESSOS_ATIVOS_ANM',
    'PROCESSOS_INATIVOS_ANM',
    'AREA_EMBARGADA_IBAMA_POLIGONO_PAMGIA',
    'AREA_PLANTADA_SOJA_ARGENTINA_2024_2025',
    'AREA_PLANTADA_MILHO_ARGENTINA_2024_2025',
    'DESMATAMENTO_VEGA_COM_SOJA_2324_VEGA_PARAGUAI',
    'AREAS_PROTEGIDAS_COM_SOJA_2324_VEGA_PARAGUAI',
    'TERRA_INDIGENA_COM_SOJA_2324_VEGA_PARAGUAI',
    'DESMATAMENTO_VEGA_2025_COM_SOJA_2425_VEGA_PARAGUAI',
    'AREAS_PROTEGIDAS_COM_SOJA_2425_VEGA_PARAGUAI',
    'TERRA_INDIGENA_COM_SOJA_2425_VEGA_PARAGUAI',
    'DESMATAMENTO_VEGA_2025_COM_SOJA_2526_VEGA_PARAGUAI',
    'AREAS_PROTEGIDAS_COM_SOJA_2526_VEGA_PARAGUAI',
    'TERRA_INDIGENA_COM_SOJA_2526_VEGA_PARAGUAI',
    'AREA_EMBARGADA_GDF',
    'AREA_EMBARGADA_GO_PONTO',
    'AREA_EMBARGADA_RS',
    'AREA_EMBARGADA_AUTO_INFRACAO_SP',
    'AUTO_INFRACAO_IPAAM',
    'AUTO_INFRACAO_TO',
    'AREAS_EMBARGADAS_TO',
    'TERMO_EMBARGO_IPAAM',
    'EMBARGOS_GO_LISTA',
    'DETER_PANTANAL',
    'ZONA_AMORTECIMENTO_UNIDADE_CONSERVACAO',
    'ZONA_AMORTECIMENTO_TERRA_INDIGENA',
    'PLANICIE_ALAGAVEL_PANTANAL',
    'APN_AREA_MARINA_PROTEGIDA',
    'APN_RESERVA_NATURAL_DEFENSA',
    'APN_SIFAP',
    'APP_ARGENTINA_POLIGONOS',
    'APP_ARGENTINA_PONTOS',
    'APRIA_PATRIMONIO_DA_HUMANIDAD_PUNTOS',
    'APRIA_RESERVA_DE_LA_BIOSFERA',
    'APRIA_SITIOS_RAMSAR',
    'PROTECTED_PLANET_ARGENTINA',
    'TERRA_INDIGENA_ARGENTINA',
    'AICA_DE_ARGENTINA',
    'OTBN_ARGENTINA',
    'PRODES_RESIDUOS_PAMPA',
    'PRODES_RESIDUOS_AMAZONIA',
    'PRODES_RESIDUOS',
    'PRODES_RESIDUOS_CERRADO',
    'PRODES_RESIDUOS_PANTANAL',
    'PRODES_RESIDUOS_MATA_ATLANTICA',
    'PRODES_RESIDUOS_CAATINGA',
    'FLORESTA_NATURAL_EUA_2007',
    'PASTAGEM_EUA_2007',
    'TURFA_EUA',
    'AREA_UMIDA_EUA',
    'AREAS_PROTEGIDAS_EUA',
    'TERRAS_INDIGENAS_EUA',
    'GLEBA_DESLOCADA',
    'AREA_EMBARGADA_MS',
    'AUTO_INFRACAO_PI',
    'AUTO_INFRACAO_RS',
    'QUILOMBOLAS_BA',
    'QUILOMBOLAS_MARANHAO',
    'AREA_PLANTADA_CAFE_BRASIL_DESMATAMENTO_COM_ANO',
    'AREA_PLANTADA_CAFE_BRASIL_DESMATAMENTO_SEM_ANO',
    'GLOBAL_FOREST_WATCH',
    'EUDR_FOREST_COVER_2020',
    'DESMATAMENTO_HANSEN',
    'CONVERSAO_VEGETACAO_NATIVA'
];
